import { useStore } from "../../../../store/store";
import { translations } from "../../../../configs/translations";
import './CaseShopCard.css';
import { CasesPreview } from "../../cases/case/CasesPreview";
import { JSX, useState } from "react";

export const CaseShopCard = ({ name, price, onBuy, onCardClick }: { name: string; price: number; onBuy: (e: any) => void; onCardClick: () => void }) => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    const [caseImages, setCaseImages] = useState<JSX.Element[]>([]);
    
    return (
        <div className="case-shop-card-container"
            onClick={onCardClick}
        >
            <CasesPreview setCaseImages={setCaseImages} /> 

            <div className="case-shop-card-image">
                <div className="case-shop-card-image-car" >
                    {caseImages[0]}
                </div>
            </div>

            <div className="case-shop-card-content">
                <h3 className="case-shop-card-title">{name}</h3>
                <div className="case-shop-card-price-container">
                    <p>{price}</p>
                    <img src="./icons/32px/dp.png" alt="coins" />
                </div>
            </div>
        </div>
    );
};